"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _uuid = _interopRequireDefault(require("uuid"));

var _Label = _interopRequireDefault(require("../Label/Label"));

require("./Checkbox.scss");

var _excluded = ["name", "value", "label", "hideLabel", "isReversed", "isJustified", "onChange", "checked", "hasError", "className", "labelClassName", "indeterminate", "checkboxRef"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var propTypes = {
  /** The value of the input */
  value: _propTypes.string.isRequired,

  /** The label describing the checkbox*/
  label: _propTypes.string.isRequired,

  /** Visually hide the label */
  hideLabel: _propTypes.bool,

  /** Visual presentation of an hasError in the input */
  hasError: _propTypes.bool,

  /** Reverse the visual order of text and switch */
  isReversed: _propTypes.bool,

  /** Force text and switch to opposite sides */
  isJustified: _propTypes.bool,

  /** The component will generate an id for you.<br>
   * If you need to create your own, pass it in as a prop */
  id: _propTypes.string,

  /** The name is used to group checkboxes */
  name: _propTypes.string,

  /** Make a checkbox input checked by default*/
  checked: _propTypes.bool,

  /** Callback function for the checkbox */
  onChange: _propTypes.func,

  /** Make a checkbox input disabled*/
  disabled: _propTypes.bool,

  /** Add your own custom class names to the component */
  className: _propTypes.string,

  /** Add your own custom class names to the label */
  labelClassName: _propTypes.string,

  /** Sets the checkbox in an indeterminate state masking the checked or unchecked state. */
  indeterminate: _propTypes.bool,

  /** Reference that can be used for setting focus to the component */
  checkboxRef: (0, _propTypes.oneOfType)([_propTypes.func, (0, _propTypes.shape)({
    current: (0, _propTypes.instanceOf)(_propTypes.element)
  })])
};
var defaultProps = {
  indeterminate: false
}; // Merges refs

var mergeRefs = function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var filteredRefs = refs.filter(Boolean);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 0) return filteredRefs[0];
  return function (inst) {
    var _iterator = _createForOfIteratorHelper(filteredRefs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ref = _step.value;

        if (typeof ref === 'function') {
          ref(inst);
        } else if (ref) {
          ref.current = inst;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
};
/** Use checkboxes to let the users pick a **single** option or **multiple** options. */


var Checkbox = /*#__PURE__*/function (_Component) {
  _inherits(Checkbox, _Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this, props);
    _this.id = props.id || "rds-checkbox-".concat(_uuid.default.v4());
    _this.checkbox = /*#__PURE__*/_react.default.createRef();
    return _this;
  } // Set the indeterminate state


  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkbox.current.indeterminate = this.props.indeterminate;
    } // Update the indeterminate state if the prop changes

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.indeterminate !== this.props.indeterminate) {
        this.checkbox.current.indeterminate = this.props.indeterminate;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          value = _this$props.value,
          label = _this$props.label,
          hideLabel = _this$props.hideLabel,
          isReversed = _this$props.isReversed,
          isJustified = _this$props.isJustified,
          onChange = _this$props.onChange,
          checked = _this$props.checked,
          hasError = _this$props.hasError,
          className = _this$props.className,
          labelClassName = _this$props.labelClassName,
          indeterminate = _this$props.indeterminate,
          checkboxRef = _this$props.checkboxRef,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var componentClassNames = (0, _classnames.default)('rds-checkbox', {
        'rds-checkbox--is-reversed': isReversed,
        'rds-checkbox--is-justified': isJustified,
        'rds-checkbox--has-error': hasError,
        'rds-checkbox--hide-label': hideLabel
      }, className);
      var labelClassNames = (0, _classnames.default)('rds-checkbox__label', labelClassName);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: componentClassNames
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        className: 'rds-checkbox__input',
        type: "checkbox",
        name: name,
        id: this.id,
        value: value,
        onChange: onChange,
        checked: checked
      }, indeterminate && {
        'aria-checked': 'mixed'
      }, {
        "aria-invalid": hasError,
        ref: mergeRefs(this.checkbox, checkboxRef)
      }, rest)), /*#__PURE__*/_react.default.createElement(_Label.default, {
        htmlFor: this.id,
        labelText: label,
        className: labelClassNames
      }, indeterminate ? /*#__PURE__*/_react.default.createElement("svg", {
        focusable: "false",
        width: "22px",
        height: "22px",
        viewBox: "0 0 22 22"
      }, /*#__PURE__*/_react.default.createElement("polyline", {
        points: "4 10 4 12 18 12 18 10"
      })) : /*#__PURE__*/_react.default.createElement("svg", {
        focusable: "false",
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20"
      }, /*#__PURE__*/_react.default.createElement("polyline", {
        points: "4 11 8 15 16 6"
      }))));
    }
  }]);

  return Checkbox;
}(_react.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
var _default = Checkbox;
exports.default = _default;